import { render } from "./CreateCenterPage.vue?vue&type=template&id=1889747d&ts=true"
import script from "./CreateCenterPage.vue?vue&type=script&lang=ts"
export * from "./CreateCenterPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/System/Centers/CreateCenterPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1889747d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1889747d', __exports__)) {
    api.reload('1889747d', __exports__)
  }
  
  module.hot.accept("./CreateCenterPage.vue?vue&type=template&id=1889747d&ts=true", () => {
    api.rerender('1889747d', render)
  })

}


export default __exports__